import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#removeEmptyHeadings();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Removes empty heading elements (h1-h6) from the rendered RTE content.
   * Blog rich-text editors frequently leave behind empty <h2></h2> or
   * <h4><strong></strong></h4> markers when authors delete content without
   * clearing the block formatting. These empty headings trip WCAG ARIA 1.2
   * / 5.2.8 (headings must not be empty).
   */
  #removeEmptyHeadings() {
    this.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
      // textContent.trim() catches whitespace-only headings. We also want to
      // keep headings that contain meaningful media (an image with alt text).
      const hasVisibleText = heading.textContent.trim().length > 0;
      const hasLabelledImage = heading.querySelector('img[alt]:not([alt=""])');
      if (!hasVisibleText && !hasLabelledImage) {
        heading.remove();
      }
    });
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
